import React, { useState, useEffect, useContext } from "react";
import { useHistory } from 'react-router-dom';
import { Card } from "@mui/material";
import { Button, Typography } from "@material-ui/core";
import Modals from "../../components/modal";
import _ from 'lodash';

/////////Form////////////
import SFPEditForm from "../IMAM_SFP/SFPEditForm"

////////Controls////////
import OTPPatientSearchBar from "../../components/controls/OTPPatientSearchBar";

////////API////////
import * as edit from '../../modals/editImamShow'

const EditOTPForm = props => {
    //FPPatientData
  
  const [searchData, setSearchData] = useState([])
  const [tableData, setTableData] = useState([])
    
    ///////Background Data///////////
    const [loading, setLoading] = useState(false);
    const [editPage, setEditPage] = useState(false)

    /* useEffect(() => {
        const fn = async () => {
          setLoading(true)
          const searchData = await edit.editImamShow()
          if(searchData)
          {
            setSearchData(searchData.data.data.editImamShow)
            console.log("IMAM getPatientForSearch => ", searchData.data.data.editImamShow)
          }
          setLoading(false)
        }
    
        fn();
    
      }, [])  */

      useEffect(() => {
        const fn = async () => {
            const edit = sessionStorage.getItem('editSFPPatient')
            setEditPage(edit)
            console.log("editSFPPatient from SFP edit form", edit)
        }
        fn();
    }, [sessionStorage.getItem('editSFPPatient')])


    return(
        <div style={{ background: '#fcf0f2' }}>
      <Modals open={loading} />
      <Card style={{ background: '#fcf0f2' }}>
        {(editPage === "false") ?
          <><Typography variant="h5" align="center" style={{ color: '#53344d', background: '#fcf0f2', fontWeight: 'bold', padding: '1%' }}>
            IMAM-SFP Information</Typography>
            <OTPPatientSearchBar placeholder="Enter Name or ID..."  searchData={searchData} /* tableData={RHPatientData} *//></>

          : <SFPEditForm editPage={editPage}></SFPEditForm>}


      </Card >

    </div >
    )
}

export default EditOTPForm;